import { Suspense, lazy } from 'react';
const SearchForm = lazy(() => import('./StartPageSearch/SearchForm'));
import SearchFormFallback from './StartPageSearch/SearchFormFallback';

import { FilterEstateTags } from '~js/React/services/generatedApi';

export const shouldShowSearchResults = (
  hideAC: boolean,
  acResults: FilterEstateTags | null | undefined
): boolean => {
  return (
    !hideAC &&
    acResults &&
    !!(
      acResults.areas.length ||
      acResults.counties.length ||
      acResults.municipalities.length ||
      acResults.estates.length
    )
  );
};

export const shouldShowNoSearchResults = (
  hideAC: boolean,
  acResults: FilterEstateTags | null | undefined
): boolean => {
  return (
    !hideAC &&
    acResults &&
    !(
      acResults.areas.length ||
      acResults.counties.length ||
      acResults.municipalities.length ||
      acResults.estates.length
    )
  );
};

const AutocompleteStartpageComponent = () => {
  return (
    <Suspense fallback={<SearchFormFallback />}>
      <SearchForm
        shouldShowSearchResults={shouldShowSearchResults}
        shouldShowNoSearchResults={shouldShowNoSearchResults}
      />
    </Suspense>
  );
};
export default AutocompleteStartpageComponent;
